import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useResendCodeMutation, useVerifyEmailMutation } from "../features/auth/authApi";

const VerifyEmail = ({ email, setOpenVerifyEmailModal, setOpenLoginModal }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [secondsLeft, setSecondsLeft] = useState(60);
  const [message, setMessage] = useState(null);
  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();
  const [resendCode, { isLoading: isResending }] = useResendCodeMutation();

  useEffect(() => {
    if (!secondsLeft) return undefined;
    const timer = setInterval(() => setSecondsLeft((seconds) => seconds - 1), 1000);
    return () => clearInterval(timer);
  }, [secondsLeft]);

  const updateCode = (index, value) => {
    const digit = value.replace(/[^a-zA-Z0-9]/g, "").slice(-1).toUpperCase();
    const nextCode = code.split("");
    nextCode[index] = digit;
    setCode(nextCode.join("").slice(0, 4));
    if (digit) document.getElementById(`verification-code-${index + 1}`)?.focus();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage(null);

    try {
      const data = await verifyEmail({
        email,
        purpose: "registration",
        code: code.trim().toUpperCase(),
      }).unwrap();
      setMessage({ status: true, text: data?.message || t("verifyEmail.success") });
      setTimeout(() => {
        setOpenVerifyEmailModal(false);
        setOpenLoginModal(true);
      }, 800);
    } catch (error) {
      setMessage({
        status: false,
        text: error?.data?.message || error?.data?.error || t("verifyEmail.errors.failed"),
      });
    }
  };

  const handleCodePaste = (event) => {
    event.preventDefault();
    const pasted = event.clipboardData.getData("text").replace(/[^a-zA-Z0-9]/g, "").slice(0, 4).toUpperCase();
    setCode(pasted);
    document.getElementById(`verification-code-${Math.min(pasted.length, 3)}`)?.focus();
  };

  const handleResend = async () => {
    try {
      await resendCode({ email, purpose: "registration" }).unwrap();
      setSecondsLeft(60);
      setCode("");
      setMessage(null);
    } catch (error) {
      setMessage({ status: false, text: error?.data?.message || error?.data?.error || "Չհաջողվեց կրկին ուղարկել կոդը։" });
    }
  };

  return (
    <section className="account d-flex">
      <img src="assets/images/thumbs/account-img.png" alt="" className="account__img" />
      <div className="account__left d-md-flex d-none flx-align section-bg position-relative z-index-1 overflow-hidden">
        <img src="assets/images/shapes/pattern-curve-seven.png" alt="" className="position-absolute end-0 top-0 z-index--1 h-100" />
        <div className="account-thumb"><img src="assets/images/thumbs/banner-img.png" alt="" /></div>
      </div>
      <div className="account__right padding-y-120 flx-align">
        <div className="account-content">
          <h4 className="account-content__title text-capitalize">{t("verifyEmail.title")}</h4>
            <p>{t("verifyEmail.description", { email })}</p>
            <p className="verify-email-success">{t("verifyEmail.sent", { email })}</p>
          <form onSubmit={handleSubmit} className="row">
            {message && <div className={`col-12 ${message.status ? "text-success" : "text-danger"}`}>{message.text}</div>}
            <div className="col-12">
              <label htmlFor="verification_code" className="form-label font-18 font-heading fw-600">
                {t("verifyEmail.code")}
              </label>
              <div className="verify-code-inputs">
                {[0, 1, 2, 3].map((index) => <input key={index} id={`verification-code-${index}`} value={code[index] || ""} onPaste={handleCodePaste} onChange={(event) => updateCode(index, event.target.value)} className="common-input common-input--bg" maxLength={1} autoComplete={index === 0 ? "one-time-code" : "off"} required />)}
              </div>
            </div>
            <div className="col-12">
              <button type="submit" disabled={isLoading} className="btn btn-main btn-lg w-100 pill">
                {isLoading ? t("verifyEmail.verifying") : t("verifyEmail.verify")}
              </button>
            </div>
            <div className="col-12 verify-resend">
              {secondsLeft > 0 ? t("verifyEmail.resendIn", { seconds: secondsLeft }) : <button type="button" onClick={handleResend} disabled={isResending}>{isResending ? "..." : t("verifyEmail.resend", "Կրկին ուղարկել")}</button>}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default VerifyEmail;
